import React from 'react';
import SignIn from './containers/SignIn';

function Index(props: any) {
    return (
        <SignIn />
    );
}

export default Index;